import React, { createContext } from 'react';
import { rootStore, RootStore } from '../stores/RootStore';

export const RootContext = createContext<RootStore>(rootStore);

export type StoreComponent = React.FC<{
  store: RootStore;
  children: React.ReactNode;
}>;

/**
 *
 * @param children {ReactNode}
 * @param store {RootStore}
 * @returns Context API Store Provider
 */
export const StoreProvider: StoreComponent = ({ children, store }): React.ReactElement => {
  return <RootContext.Provider value={store}>{children}</RootContext.Provider>;
};
